import type { RouteConfig } from 'vue-router'
import { ROUTE_NAMES } from './routeNames.const'

export const routeTransmission = ((): RouteConfig => {
  return {
    path: '/transmission',
    name: ROUTE_NAMES.transmissionCircuit.transmissionPagesContainer,
    component: () =>
      import(
        /* webpackChunkName: "TransmissionCircuit" */ 'src/circuits/transmission-circuit/TransmissionCircuitPageContainer.vue'
      ),
  }
})()
